<!--
@component
NoIndex

Adds a `<meta name="robots" content="noindex, nofollow">` tag to the
current page's `<head>`. Mount this from any route that should never be
crawled or indexed (dev/tooling routes like /sharecards, /embed-previewer,
share-card prerender pages and /embeds/* widgets).

Page-level `<svelte:head>` writes win over layout-level ones in SvelteKit
so a layout that omits the tag won't accidentally re-expose the page to
crawlers.
-->

<script lang="ts">
  // Marker component — no props. Empty `<script>` block is here so the
  // file is recognised as a Svelte module with TypeScript typings (the
  // lang="ts" hint flips type generation on).
</script>

<svelte:head>
  <meta name="robots" content="noindex, nofollow" />
  <meta name="googlebot" content="noindex, nofollow" />
</svelte:head>
